import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { StepsContextProvider } from "./context/stepsContext";
import "./index.css";
import { Provider } from "react-redux";
import store from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <StepsContextProvider>
        <App />
      </StepsContextProvider>
    </Provider>
  </React.StrictMode>
);
